export default "__VITE_ASSET__KHGUAFHw__"